module.exports = __webpack_public_path__ + "static/media/cover-firewall-basics.a0e39754.jpg";